var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsPlans01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 0.75px;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ads Plans") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.86,
    y1: 13.6,
    x2: 9.44,
    y2: 13.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.86,
    y1: 9.48,
    x2: 13.1,
    y2: 9.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.86,
    y1: 5.6,
    x2: 13.1,
    y2: 5.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1499",
    className: "cls-2",
    d: "M12.26,19.05,18,13.35l2.84,2.85L15.1,21.89l-2.82,0ZM19,12.36,20.33,11a1.09,1.09,0,0,1,1.56,0l1.28,1.28a1.09,1.09,0,0,1,0,1.56L21.79,15.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.27,10.42V3.49a1.47,1.47,0,0,0-1.39-1.55h-14A1.47,1.47,0,0,0,1.5,3.49V20.85a1.47,1.47,0,0,0,1.38,1.54h7.64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsPlans01);
export default __webpack_public_path__ + "static/media/Ads_Plans_01.fad9a754e2243cfbf246826fbfc43a0f.svg";
export { ForwardRef as ReactComponent };